// extracted by mini-css-extract-plugin
export default {"flex-container":"Flex_flex-container__fAV+A","flex-container-row":"Flex_flex-container-row__QSM-e","flex-container-column":"Flex_flex-container-column__ZHzF7"};